export const MAP_KEY = 'AIzaSyA_JNe5vljxG4iJCiQYJVFMGMNsNYql6cg';
// export const MAP_KEY = 'AIzaSyASMKgBdouMSl3otN5KvxImHFR9n-X7ey4';
export const PAYSTACK_KEYS = {
  // test secret key
  SECRET_KEY: process.env.REACT_APP_SECRET_KEY,

  // test public key
  PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
}
